// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2XM0k","image":"Header_image__mRc6c","name":"Header_name__2_qXf","info":"Header_info__3QUTZ","infoRow":"Header_infoRow__kd0mj"};